import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Head from 'next/head';
import { Gavel, FileText } from 'lucide-react';
export default function TermsPage() {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>Terms of Service | Sizzle</title><meta name="description" content="The terms and conditions for using the Sizzle platform." /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-4 mb-6"><div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center text-primary-600"><Gavel className="w-6 h-6" /></div><h1 className="text-4xl font-black text-gray-900">Terms of Service</h1></div>;
    t2 = <p className="text-gray-600 text-lg">Welcome to Sizzle. By using our platform, you agree to the following terms and conditions.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-white rounded-[3rem] p-12 mb-12 shadow-sm border border-gray-100">{t1}{t2}<div className="mt-8 pt-8 border-t border-gray-50 flex items-center gap-2 text-sm text-gray-400"><FileText className="w-4 h-4" /><span>Last Updated: {"January 28, 2026"}</span></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-2xl font-bold text-gray-900 mb-6">1. Acceptance of Terms</h2>;
    t5 = <p>By accessing or using Sizzle (the "Service"), you agree to be bound by these Terms of Service. If you do not agree, you may not use the Service.</p>;
    t6 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">2. Use of the Service</h2>;
    t7 = <p>The Service is a platform for discovering and curating food and beverage products. You agree to:</p>;
    t8 = <ul><li>Provide accurate information when creating an account.</li><li>Use the Service only for lawful purposes.</li><li>Not attempt to disrupt the Service or access data you are not authorized to see.</li><li>Maintain the security of your account credentials.</li></ul>;
    t9 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">3. User Content</h2>;
    t10 = <p>You may be able to create collections and add comments. You retain ownership of your content, but you grant Sizzle a worldwide, royalty-free license to display and distribute that content on the platform.</p>;
    t11 = <p>We reserve the right to remove any content that violates these terms or is otherwise inappropriate.</p>;
    t12 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">4. Intellectual Property</h2>;
    t13 = <p>All content provided by Sizzle, including logos, designs, and software, is the property of Sizzle CPG Labs and protected by intellectual property laws.</p>;
    t14 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">5. Disclaimers</h2>;
    t15 = <p>Sizzle is provided "as is" and "as available." We do not guarantee that the Service will always be error-free or uninterrupted. Product information is provided for discovery purposes and should be verified with the original brand or retailer.</p>;
    t16 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">6. Limitation of Liability</h2>;
    t17 = <p>Sizzle will not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>;
    t18 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">7. Governing Law</h2>;
    t19 = <p>These terms are governed by the laws of New Zealand. Any disputes will be resolved in the courts of New Zealand.</p>;
    t20 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">8. Changes to Terms</h2>;
    t21 = <p>We may update these terms at any time. Your continued use of the Service after changes are posted constitutes your acceptance of the new terms.</p>;
    t22 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">9. Contact</h2>;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
    $[12] = t18;
    $[13] = t19;
    $[14] = t20;
    $[15] = t21;
    $[16] = t22;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
    t16 = $[10];
    t17 = $[11];
    t18 = $[12];
    t19 = $[13];
    t20 = $[14];
    t21 = $[15];
    t22 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <>{t0}<div className="min-h-screen bg-gray-50 pt-32 pb-24"><div className="container mx-auto px-6"><div className="max-w-4xl mx-auto">{t3}<div className="bg-white rounded-[3rem] p-12 shadow-sm border border-gray-100 prose prose-gray max-w-none">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}<p>Questions? Reach out at{" "}<a href="mailto:hello@sizzlecpg" className="text-primary-600 font-bold no-underline hover:underline">hello@sizzlecpg.com</a></p></div></div></div></div></>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  return t23;
}